import React from 'react';
import './stylesMarketplace.css';

/**
 * A function that returns a div with a className that is a string that is a concatenation of the
 * string "start1 start-1 stateStart" and the value of the variable estado.
 */
function Start(props) {
	/* Destructuring the props object and assigning the value of the estado property to the estado
variable. */
	const {estado} = props;

	return (
		<div className={`start1 start-1 stateStart` + estado}>{estado === true ? '★' : '☆'}</div>
	);
}

export default Start;
